import FilterSelect from '@/components/filters/FilterSelect';
import SummaryCard from '@/components/cards/SummaryCard';
import BarChart from '@/components/charts/BarChart';
import GenderLegend from '../components/GenderLegend';
import { timeRangeOptions } from '../constants/options';
import { SummaryData, TimeRange } from '../constants/types';

interface Props {
  developerSummaryData: SummaryData[];
  developerChartData: any[];
  developerTimeRange: TimeRange;
  setDeveloperTimeRange: (v: TimeRange) => void;
  timeRangeOptions: any[];
}

const DevelopersSection: React.FC<Props> = ({
  developerSummaryData,
  developerChartData,
  developerTimeRange,
  setDeveloperTimeRange,
  timeRangeOptions,
}) => (
  <div className='bg-white p-10 rounded-[24px] space-y-8'>
    <div className='flex items-center justify-between'>
      <h2 className='text-[32px] font-[700]'>Developers</h2>
      <div className='flex space-x-2'>
        <GenderLegend />
        <FilterSelect
          value={developerTimeRange}
          onChange={(e) => setDeveloperTimeRange(e.target.value)}
          options={timeRangeOptions}
        />
      </div>
    </div>
    <div className="grid grid-cols-4 gap-4">
          {developerSummaryData.map((d) => (
            <SummaryCard key={d.label} {...d} />
          ))}
        </div>
    <BarChart
      data={developerChartData}
    />
  </div>
);

export default DevelopersSection;
